import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/atencao-basica`

    const headers = { responseType: "arraybuffer" }

    return {
        termoRecusaCadastro(id)
        {
            return repository.get(`${baseUrl}/termo-recusa-cadastro/${id}`, headers)
        },
        ficha(id)
        {
            return repository.get(`${baseUrl}/ficha/${id}`, headers)
        },
        fichaCadastroDomiciliar(id)
        {
            return repository.get(`${baseUrl}/ficha-cadastro-domiciliar/${id}`, headers)
        },
        fichaResidentes(id)
        {
            return repository.get(`${baseUrl}/ficha-residente/${id}`, headers)
        },
        relatorioAtendimentoOdontologico(queryParms) {
            return repository.get(`${baseUrl}/relatorio-atendimento-odontologico?${urlUtil.serialize(queryParms)}`, headers)
        },
        fichaAtividadeColetiva(id)
        {
            return repository.get(`${baseUrl}/ficha-atividade-coletiva/${id}`, headers)
        },
        relatorioCadastroConsistente(params)
        {
            return repository.get(`${baseUrl}/relatorio-cadastro-consistente?${urlUtil.serialize(params)}`, headers)
        },
        relatorioEstatisticoAtendimento(params)
        {
            return repository.get(`${baseUrl}/relatorio-estatistico-atendimento?${urlUtil.serialize(params)}`, headers)
        },
        relatorioInconsistencia(params)
        {
            return repository.get(`${baseUrl}/relatorio-inconsistencia?${urlUtil.serialize(params)}`, headers)
        },
        fichaVisitaDomiciliar(id)
        {
            return repository.get(`${baseUrl}/ficha-visita-domiciliar/${id}`, headers)
        },
        relatorioEstatisticoPacienteCadastrado(params)
        {
            return repository.post(`${baseUrl}/relatorio-estatistico-paciente-cadastrado`, params, headers)
        },
        relatorioVisitaDomiciliar(params)
        {
            return repository.get(`${baseUrl}/relatorio-visita-domiciliar?${urlUtil.serialize(params)}`, headers)
        },
    }
}
